import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  setRegisterToken,
  setRegisterFormData,
  setRoleFlag,
  getRoleFlag,
  getInviteCode as getECSiteInviteCode,
  extractRoleFlag,
  getPartnerInviteCode,
  setInviteSrcData
} from '../common_modules/components/Common';
import dataProvider from '../dataProvider';

const ClientRegister: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    let inviteCode: string | null = null;
    let inviteSrc: number | null = null;
    let inviteSite: string | null = null;
    let inviteTerms: string | null = null;
    let inviteContract: string | null = null;

    const token = setRegisterToken(location.search);
    if (!token) {
      const role = extractRoleFlag(location.pathname);
      if (role !== 'client') {
        navigate(`/register/client/error`, { replace: true });
        return;
      }
      let code = getECSiteInviteCode(location.search);
      if (code) {
        inviteCode = code;
        inviteSrc = 2;
      } else {
        code = getPartnerInviteCode(location.search);
        if (code) {
          inviteCode = code;
          inviteSrc = 1;
        } else {
          inviteCode = 'empty';
          inviteSrc = 3;
        }
      }
    } else {
      inviteSrc = 2;
    }
    console.log(inviteCode, inviteSrc);

    setRoleFlag(location.pathname);

    const checkToken = async (requestToken: string | null) => {
      try {
        const role = getRoleFlag();
        if (!role) {
          navigate(`/register/client/error`, { replace: true });
          return;
        }

        let token: string;
        if (inviteCode !== null) {
          const response = await dataProvider.register(
            { inviteCode: inviteCode, inviteSrc: inviteSrc },
            `registers/${role}s/issue-token`,
            'POST'
          );

          if (!response.data || !response.data.token) {
            navigate(`/register/client/error`, { replace: true });
            return;
          }

          const { token: issuedToken, clientName, terms, contract } = response.data;
          inviteSite = clientName;
          inviteTerms = terms;
          inviteContract = contract;

          let newtoken = setRegisterToken(location.search, issuedToken);
          if (!newtoken) {
            navigate(`/register/client/error`, { replace: true });
            return;
          }
          token = newtoken;
        } else {
          if (!requestToken) {
            navigate(`/register/client/error`, { replace: true });
            return;
          }
          token = requestToken;
        }

        let endpoint;
        if (role.endsWith('-staff')) {
          endpoint = `registers/${role.split('-')[0]}s/check-staff-token/${token}`;
        } else {
          endpoint = `registers/${role}s/check-token/${token}`;
        }

        const response = await dataProvider.register({}, endpoint, 'GET');
        const { registerStatus, clientName, ...formData } = response.data; // clientName を取得

        // clientName を inviteSite に設定
        inviteSite = clientName;
        setInviteSrcData(inviteSrc, inviteSite, null, inviteTerms, inviteContract);
        setRegisterFormData(formData);
        switch (registerStatus) {
          case 0:
            if (role?.includes('staff')) {
              navigate(`/register/${role}/create-staff`, { replace: true });
            } else {
              navigate(`/register/${role}/start-register`, { replace: false });
            }
            break;
          case 1:
            navigate(`/`, { replace: true });
            break;
          case 2:
          case 3:
            navigate(`/register/${role}/create-staff`, { replace: true });
            break;
          case 4:
          case 5:
          default:
            navigate(`/register/${role}/error`, { replace: true });
            break;
        }
      } catch (error) {
        console.error('Error checking token:', error);
        navigate(`/register/client/error`, { replace: true });
      }
      setIsLoading(false);
    };

    setIsLoading(true);
    checkToken(token);
  }, [location.search, location.pathname, navigate, isLoading]);

  return null;
};

export default ClientRegister;
